import { fetchWithToken } from "../../functions/fetch";
import { useEffect, useState } from "react";
import { addSearchedField, sortByTopField } from "../../functions/announcement";

import PageContainer from "../common/PageContainer";
import SearchBar from "../common/SearchBar";
import RouteProtection from "../common/RouteProtection";
import Header from "../common/Header";
import NewItemButton from "../common/NewItemButton";
import AnnouncementList from "./AnnouncementList";
import AnnouncementPopUp from "./AnnouncementPopUp";
import { useUpdateAnnouncement } from "../../contexts/updateAnnouncementContext";

const AnnouncementPage = () => {
  const [unfilteredAnnouncements, setUnfilteredAnnouncements] = useState([]);
  const [filteredAnnouncements, setFilteredAnnouncements] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [method, setMethod] = useState("POST"); // POST/PUT for pop up action
  const [curAnnouncement, setCurAnnouncement] = useState(null);
  const { updateAnnouncement, setUpdateAnnouncement } = useUpdateAnnouncement();
  const [firstRender, setFirstRender] = useState(true);

  const fetchAnnouncements = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/announcement`,
    );

    if (res.status === 200) {
      // add searchedField to unfiltered data
      const announcements = sortByTopField(res.announcements, "createdAt");

      addSearchedField(announcements);

      setUnfilteredAnnouncements(announcements);
      setFilteredAnnouncements(announcements); // shown default value

      // reset the fetch state
      setUpdateAnnouncement(false);
      setFirstRender(false);
    } else {
      console.error(res);
    }
  };

  const showEditPopUp = (announcement) => {
    setShowPopUp(true);
    setMethod("PUT");
    setCurAnnouncement(announcement);
  };

  useEffect(() => {
    if (firstRender || updateAnnouncement) {
      fetchAnnouncements();
    }
  }, [updateAnnouncement]);

  return (
    <>
      <RouteProtection />
      <Header />
      {showPopUp ? (
        <AnnouncementPopUp
          curAnnouncement={curAnnouncement}
          setShowPopUp={setShowPopUp}
          method={method}
          setUnfilteredAnnouncements={setUnfilteredAnnouncements}
        />
      ) : (
        <></>
      )}
      <PageContainer>
        <div className="flex justify-between">
          <NewItemButton
            itemName="公告"
            setShowPopUp={setShowPopUp}
            setMethod={setMethod}
          />
          <SearchBar
            items={unfilteredAnnouncements}
            setFunction={setFilteredAnnouncements}
          />
        </div>
        <AnnouncementList
          announcements={filteredAnnouncements}
          showEditPopUp={showEditPopUp}
        />
      </PageContainer>
    </>
  );
};

export default AnnouncementPage;
